// Announcement form templates (routes are defined in App.js). Used by "ลงประกาศด้วยตัวเอง".
export const FORM_GROUPS = [
  {
    group: "เชิญประชุม",
    category: "ประกาศประชุม",
    forms: [
      { path: "/FinancialApproval", name: "เชิญประชุมอนุมัติการเงิน (ปิดงบ)" },
      { path: "/DirectorChange", name: "เชิญประชุม เปลี่ยนกรรมการ" },
      { path: "/DividedPaymant", name: "เชิญประชุม จ่ายเงินปันผล" },
      { path: "/CompanyRegulations", name: "เชิญประชุมแก้ไขข้อบังคับบริษัท" },
      { path: "/CapitalReduction", name: "เชิญประชุมลดทุน" },
      { path: "/AmendmentofObjectives", name: "เชิญประชุมแก้ไขวัตถุประสงค์" },
    ],
  },
  {
    group: "ประกาศบริษัท",
    category: "ประกาศบริษัท",
    forms: [
      { path: "/Notice1Form", name: "ประกาศเลิกบริษัท ครั้งที่ 1" },
      { path: "/Notice2Form", name: "ประกาศเลิกบริษัท ครั้งที่ 2" },
      { path: "/Notice3Form", name: "ประกาศเลิกบริษัท ครั้งที่ 3" },
      { path: "/Notice4Form", name: "ประกาศเลิกบริษัท ครั้งที่ 4" },
      { path: "/NoticeofCapitalReduction", name: "ประกาศลดทุน" },
      { path: "/NoticeTransformPartnershipToCompany_TH", name: "ประกาศแปรสภาพห้างหุ้นส่วนจำกัดเป็นบริษัทจำกัด" },
    ],
  },
  {
    group: "ภาษาอังกฤษ",
    category: "ประกาศประชุม",
    forms: [
      { path: "/MeetingInvitationEN", name: "เชิญประชุม อนุมัติการเงิน (ปิดงบ - ภาษาอังกฤษ)" },
      { path: "/InvitationEGM_EN", name: "ประกาศเลิกบริษัท English ขั้นตอน 1" },
      { path: "/InvitationEGM2_EN", name: "ประกาศเลิกบริษัท English ขั้นตอน 2" },
      { path: "/InvitationEGM3_EN", name: "ประกาศเลิกบริษัท English ขั้นตอน 3" },
    ],
  },
  {
    group: "อื่น ๆ",
    category: "ประกาศบริษัท",
    forms: [
      { path: "/Distribute", name: "จ่ายเงินปันผล" },
      { path: "/RaiseFunds", name: "เพิ่มทุน" },
      { path: "/Relocation", name: "ย้ายที่ตั้งสำนักงานข้ามจังหวัด" },
      { path: "/Dissolution", name: "เลิกห้างหุ้นส่วนจำกัด" },
    ],
  },
];

export function findFormType(pathname) {
  const p = String(pathname || "").toLowerCase();
  for (const g of FORM_GROUPS) {
    const f = g.forms.find((x) => x.path.toLowerCase() === p);
    if (f) return { ...f, category: g.category };
  }
  return null;
}
